interface CertificateListItem {
  courseId?: string;
  courseName: string;
}

interface CourseIdentity {
  _id?: string;
  title?: string;
}

// Matches by courseId when the certificate carries one: courseName is a
// snapshot of the title at issue time, so it stops matching once the
// course is renamed. Falls back to courseName for certificates listed
// without a courseId (service-evaluation versions that predate returning
// it in /certificate/list/:username).
export const findCertificateForCourse = <T extends CertificateListItem>(
  certificates: T[] | null | undefined,
  course: CourseIdentity | null | undefined
): T | undefined =>
  (certificates || []).find((certificate) =>
    certificate.courseId
      ? !!course?._id && String(certificate.courseId) === String(course._id)
      : certificate.courseName === course?.title
  );
